<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title>
      {{ techniqueName }} - {{ modalTitle }}
    </template>

    <template #body>
      <div class="details-container">
        <div v-if="!detailsData || detailsData.length === 0" class="text-center py-5">
          <p class="text-muted">No data available</p>
        </div>
        <div v-else class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th class="text-center">Site Code</th>
                <th class="text-center">Flag Type</th>
                <th class="text-center">Field Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(detail, index) in detailsData" :key="index">
                <td class="text-center">{{ detail.siteCode }}</td>
                <td class="text-center">{{ detail.flagType }}</td>
                <td class="text-center">{{ detail.fieldName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script>
import customModal from "../customModal/customModal.vue";

export default {
  name: "SiteAffectedDetailsModal",
  components: {
    customModal
  },
  props: {
    techniqueName: {
      type: String,
      required: true
    },
    detailsData: {
      type: Array,
      required: true,
      default: () => []
    },
    modalType: {
      type: String,
      required: false,
      default: "affected",
      validator: (value) => ["affected", "notaffected"].includes(value)
    }
  },
  computed: {
    modalTitle() {
      return this.modalType === "affected" ? "Site Affected Details" : "Site Not Affected Details";
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    }
  }
};
</script>

<style scoped>
.details-container {
  padding: 10px 0;
}

.table {
  margin-bottom: 0;
}

table thead th {
  background-color: #f4f6f9;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
}

table tbody tr:hover {
  background-color: #f9f9f9;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #6c757d;
}
</style>
